import React from 'react'

// 메뉴 아이콘 — ERMORE OS(the.ermore.ai)와 같은 **모노톤 선 아이콘**이다.
//
// 한동안 이모지를 썼다. 서른세 개가 전부 같은 회색이면 눈이 아무것도 못 고른다는
// 이유였는데, 회사 화면을 OS 에 맞추기로 하면서 되돌린다 — 거기 앱 메뉴는 16px 선
// 아이콘이고 색은 글자색을 따라간다(.navIcon). 이모지는 OS 에서 **페이지 아이콘**,
// 그러니까 사람이 문서마다 골라 붙이는 자리에만 쓴다.
//
// 고르는 속도는 색 대신 **모양**으로 낸다. 같은 그림이 둘이면 없는 것과 같으므로
// 메뉴마다 다른 모양을 준다. 24 격자에 그리고 16px 로 내보낸다.
//
// 컴포넌트이므로 쓰는 쪽에서 <t.icon /> 으로 넣는다(예전 이모지처럼 {t.icon} 아님).

const S = ({ children }) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
    strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
)

export const Icon = {
  // 홈
  home: () => <S><path d="M3.5 11 12 4l8.5 7" /><path d="M6 10v9h12v-9" /><path d="M10 19v-5h4v5" /></S>,
  report: () => <S><rect x="5" y="4" width="14" height="17" rx="2" /><path d="M9 3h6v3H9z" /><path d="M9 11h6M9 15h4" /></S>,

  // 데이터
  bank: () => <S><path d="M3 9.5 12 4l9 5.5" /><path d="M5.5 10v8M10 10v8M14 10v8M18.5 10v8" /><path d="M3.5 20.5h17" /></S>,
  tax: () => <S><path d="M6 3h12v18l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5z" /><path d="M9.5 8h5M9.5 12h5" /></S>,
  card: () => <S><rect x="3" y="5.5" width="18" height="13" rx="2.5" /><path d="M3 10h18" /><path d="M7 14.5h3" /></S>,
  securities: () => <S><path d="M3.5 16.5 9 11l3.5 3.5L20 7" /><path d="M15.5 7H20v4.5" /></S>,
  master: () => <S><ellipse cx="12" cy="6" rx="7.5" ry="3" /><path d="M4.5 6v6c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3V6" /><path d="M4.5 12v6c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3v-6" /></S>,
  approve: () => <S><circle cx="12" cy="12" r="8.5" /><path d="M8.5 12.5 11 15l4.5-5" /></S>,

  // 자금
  // 쌓인 원통으로 그렸더니 기초설정(데이터베이스)과 16px 에서 똑같아 보였다 - 겹친 동전으로 가른다
  coins: () => <S><circle cx="9.5" cy="9.5" r="5.5" /><circle cx="15" cy="15" r="5.5" /></S>,
  fx: () => <S><path d="M3.5 8.5h13M13 5l3.5 3.5L13 12" /><path d="M20.5 15.5h-13M11 12l-3.5 3.5L11 19" /></S>,
  plan: () => <S><rect x="3.5" y="5" width="17" height="15" rx="2.5" /><path d="M3.5 10h17M8 3.5v3M16 3.5v3" /><path d="M8 14h3" /></S>,

  // 매출 · 원가
  cart: () => <S><path d="M3 4h2.2l2.2 10.5h10.1" /><path d="M6.6 7.5h13.6l-1.6 6" /><circle cx="9.5" cy="19" r="1.5" /><circle cx="17" cy="19" r="1.5" /></S>,
  chart: () => <S><path d="M4 20V10M9.3 20V5M14.7 20v-7M20 20V8" /></S>,
  factory: () => <S><path d="M3.5 20.5V11l5.5 3.5V11l5.5 3.5V6.5h5.5v14z" /><path d="M8 20.5v-3.5M14 20.5v-3.5" /></S>,
  box: () => <S><path d="M3.5 7.5 12 3.5l8.5 4v9L12 20.5l-8.5-4z" /><path d="M3.5 7.5 12 11.5l8.5-4M12 11.5v9" /></S>,
  tag: () => <S><path d="M4 11.5V4.5h7L20 13l-7 7z" /><circle cx="8" cy="8" r="1.3" /></S>,

  // 결산
  pnl: () => <S><rect x="4.5" y="3.5" width="15" height="17" rx="2.5" /><path d="M8.5 16v-3M12 16v-6M15.5 16v-4" /></S>,
  asset: () => <S><rect x="4" y="3.5" width="10" height="17" rx="1.5" /><path d="M14 9.5h6v11h-6" /><path d="M7 7.5h4M7 11h4M7 14.5h4M17 13h0M17 16.5h0" /></S>,
  depreciation: () => <S><path d="M3.5 7.5 9 13l3.5-3.5L20 17" /><path d="M15.5 17H20v-4.5" /></S>,
  prepaid: () => <S><rect x="3.5" y="5" width="17" height="15" rx="2.5" /><path d="M3.5 10h17M8 3.5v3M16 3.5v3" /><circle cx="16" cy="15.5" r="2.8" /><path d="M16 14v1.7l1.1.8" /></S>,
  doc: () => <S><path d="M6 3.5h7l5 5v12H6z" /><path d="M13 3.5v5h5" /><path d="M9 13h6M9 16.5h4" /></S>,
  lock: () => <S><rect x="4.5" y="10.5" width="15" height="10" rx="2.5" /><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" /><path d="M12 15v2" /></S>,

  // 전자결재
  inbox: () => <S><path d="M3.5 13.5 6 5h12l2.5 8.5v5.5h-17z" /><path d="M3.5 13.5h4l1.2 2.5h6.6l1.2-2.5h4" /></S>,
  pen: () => <S><path d="M16.5 4.5 19.5 7.5 9 18l-4 1 1-4z" /><path d="M14.5 6.5 17.5 9.5" /></S>,
  folder: () => <S><path d="M3.5 6.5h6l2 2.5h9v10.5h-17z" /></S>,
  sign: () => <S><path d="M3.5 17.5c3-7 5-7 6.5-3.5s3 3.5 4.5-1 3-4.5 4-2" /><path d="M3.5 20.5h17" /></S>,
  transfer: () => <S><path d="M4 8.5h12.5M13 5l3.5 3.5L13 12" /><path d="M20 15.5H7.5M11 12l-3.5 3.5L11 19" /></S>,
  link: () => <S><path d="M10 13.5a3.5 3.5 0 0 0 5 0l3-3a3.5 3.5 0 0 0-5-5l-1.5 1.5" /><path d="M14 10.5a3.5 3.5 0 0 0-5 0l-3 3a3.5 3.5 0 0 0 5 5l1.5-1.5" /></S>,
  archive: () => <S><rect x="3.5" y="4" width="17" height="4.5" rx="1.5" /><path d="M5 8.5v11.5h14V8.5" /><path d="M10 12.5h4" /></S>,

  // 업무 · 관리
  check: () => <S><rect x="4" y="4" width="16" height="16" rx="3" /><path d="M8.5 12.3 11 15l4.5-5.5" /></S>,
  gear: () => <S><circle cx="12" cy="12" r="3" /><path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8" /></S>,
  note: () => <S><path d="M4.5 4.5h15v10l-5 5h-10z" /><path d="M19.5 14.5h-5v5" /><path d="M8 9h8M8 12.5h4" /></S>,
  store: () => <S><path d="M4 9.5V20h16V9.5" /><path d="M3 9.5 5 4h14l2 5.5a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z" /><path d="M10 20v-5h4v5" /></S>,

  // 내보내기 · 보고서 (기초설정과 같은 모양을 쓰고 있었다)
  share: () => <S><path d="M12 15V4" /><path d="M8.5 7.5 12 4l3.5 3.5" /><path d="M5 13v5.5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V13" /></S>,
  files: () => <S><path d="M8 3.5h6l4 4v10a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 17.5V5A1.5 1.5 0 0 1 8 3.5z" /><path d="M14 3.5v4h4" /><path d="M9.5 20.5h7" /></S>,
  bell: () => <S><path d="M6.5 10a5.5 5.5 0 0 1 11 0c0 4 1.5 5.5 1.5 5.5H5s1.5-1.5 1.5-5.5z" /><path d="M10 19a2 2 0 0 0 4 0" /></S>,

  // 도움말
  manual: () => <S><path d="M4 5a2.5 2.5 0 0 1 2.5-2H11v17H6.5A2.5 2.5 0 0 0 4 19.5z" /><path d="M20 5a2.5 2.5 0 0 0-2.5-2H13v17h4.5a2.5 2.5 0 0 1 2.5 2.5z" /></S>,
}
